import { isFatEnv, isMockEnv } from '@/constant';

export const appEnv = (isFatEnv || isMockEnv) ? 'fat' : (process.env.VUE_APP_ENV || 'pro');
